/* @flow */
import React, { Component, PropTypes } from 'react';
import cx from 'classnames';

import Activity from 'entities/Activity';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';

import './styles/ActivityDetailHeader.scss';

class ActivityDetailHeader extends Component {
  static propTypes = {
    activity: PropTypes.instanceOf(Activity).isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  onClose = () => {
    if (window.history && window.history.length > 1) {
      window.history.back();
    } else {
      this.context.router.push('/campaigns');
    }
  }

  renderBack() {
    return (
      <div className="ActivityDetailHeader-back" onClick={this.onClose}>
        <div>
          <Button level="icon">
            <Glyph name="close-btn" size="large" solo />
          </Button>
        </div>
        <div className="ActivityDetailHeader-back-text">
          close
        </div>
      </div>
    );
  }

  render() {
    const cover = this.props.activity.getCover();

    return (
      <div className={cx('ActivityDetailHeader', this.props.className)} style={{ backgroundColor: cover.color }}>
        <div className="ActivityDetailHeader-img" style={{ backgroundImage: `url(${cover.image})` }} />
        {this.renderBack()}
      </div>
    );
  }
}

export default ActivityDetailHeader;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityDetailHeader.jsx